(() => {
  const openers = new WeakMap();

  const openDialog = (button) => {
    const dialog = document.getElementById(button.dataset.dialogOpen);
    if (!(dialog instanceof HTMLDialogElement)) return;

    openers.set(dialog, button);
    dialog.showModal();
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-dialog-open]');
    if (opener) {
      openDialog(opener);
      return;
    }

    const closer = event.target.closest('[data-dialog-close]');
    if (closer) {
      closer.closest('dialog')?.close();
      return;
    }

    if (event.target instanceof HTMLDialogElement) {
      const bounds = event.target.getBoundingClientRect();
      const outside = event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom;
      if (outside) event.target.close();
    }
  });

  document.addEventListener('close', (event) => {
    if (!(event.target instanceof HTMLDialogElement)) return;
    openers.get(event.target)?.focus();
    openers.delete(event.target);
  }, true);

  document.addEventListener('toggle', (event) => {
    const opened = event.target;
    if (!(opened instanceof HTMLDetailsElement) || !opened.open) return;

    document.querySelectorAll('details[open][data-exclusive-menu]').forEach((details) => {
      if (details !== opened) details.removeAttribute('open');
    });
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const details = document.querySelector('details[open][data-exclusive-menu]');
    if (!details) return;

    details.removeAttribute('open');
    details.querySelector(':scope > summary')?.focus();
  });
})();
